import { apiRequest } from '../apiSettings';

export const getMaterialReportData = () => apiRequest('get')(`/report/material`, undefined, true);

export const getMaterialSummaryReportData = () => apiRequest('get')(`/report/material-summary`, undefined, true);

export const getGltfModels = () => apiRequest('get')(`/report/gltf-models`, undefined, true);
